import { render, staticRenderFns } from "./ClientAllowedPayments.vue?vue&type=template&id=149db062"
import script from "./ClientAllowedPayments.vue?vue&type=script&lang=js"
export * from "./ClientAllowedPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports